import { SVGProps } from 'react';

export const ClipboardIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 52 52' fill='none' {...props}>
    <rect
      width={17}
      height={9}
      x={17}
      y={6}
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={2.5}
      rx={1}
    />
    <path
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={2.5}
      d='M34.67 10.827h4.335a4.335 4.335 0 0 1 4.335 4.335v26.011a4.335 4.335 0 0 1-4.335 4.335h-26.01a4.335 4.335 0 0 1-4.336-4.335v-26.01a4.335 4.335 0 0 1 4.335-4.336h4.335'
    />
  </svg>
);
